module.exports = __webpack_public_path__ + "static/media/5.6fbb806a.png";